import { ALPHA_2_ISO_3166, EUROPACE_RESIDENCE_PERMIT_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from '../../../utils/regex.utils';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#herkunft

    {
        "arbeitserlaubnisVorhanden": true | false,
        "arbeitserlaubnisBefristetBis": "YYYY-MM-DD",
        "aufenthaltstitel": "VISUM" | "AUFENTHALTSERLAUBNIS" | "NIEDERLASSUNGSERLAUBNIS" | "ERLAUBNIS_ZUM_DAUERAUFENTHALT_EU",
        "aufenthaltBefristetBis": "YYYY-MM-DD",
        "inDeutschlandSeit": "YYYY-MM-DD",
        "staatsangehoerigkeit": "ALPHA-2 Isocode",
        "steuerId": String
    }

*/
export const schemaEuropaceHerkunft = z.object({
    arbeitserlaubnisBefristetBis: z.optional(z.string().regex(regex_iso_date)),
    arbeitserlaubnisVorhanden: z.optional(z.boolean()),
    aufenthaltBefristetBis: z.optional(z.string().regex(regex_iso_date)),
    aufenthaltstitel: z.optional(z.nativeEnum(EUROPACE_RESIDENCE_PERMIT_TYPES)),
    inDeutschlandSeit: z.optional(z.string().regex(regex_iso_date)),
    staatsangehoerigkeit: z.optional(z.nativeEnum(ALPHA_2_ISO_3166)), // "ALPHA-2 Isocode"
    steuerId: z.optional(z.string()),
});

export type SchemaEuropaceHerkunft = z.infer<typeof schemaEuropaceHerkunft>;
